<template>
    <div class="f5-container">
        <div class="floor5" data-aos="fade-up">

            <div class="header">
                <div style="font-weight: bold; font-size: 32px; color: #222222;padding-top: 80px;margin-bottom: 14px;">
                    全面的安全体系认证与服务保障
                </div>
                <div style="font-size: 16px; color: #595859; line-height: 21px">多年行业数字化建设经验，深入理解行业难点，为企业数字化转型保驾护航 </div>

            </div>

            <!-- <div class="middle">
                <div v-for="(item, index) in menus" class="menu" @mouseenter="handleMouseEnter(index)">
                    <div :class="index == currentIndex ? 'menu-txt-sel' : 'menu-txt'">{{ item }}</div>
                    <div v-if="index == currentIndex" class="lin-sel"></div>
                </div>
            </div>
            <div class="line"></div> -->

            <div v-if="currentIndex == 0" class="container1 flex-row">
                <div v-for="(item, index) in dataCt1" class="item-ct1">
                    <img :src="item.img" alt="">
                    <div class="title" v-html="item.title"></div>
                </div>
            </div>

            <div v-if="currentIndex == 1" class="container2">
                <div class="ct2-title">技术创新有保障 180+项软件著作权 30+专利</div>
                <div class="ct2-subtitle">持续升级</div>
                <div class="flex-row center">
                    <div v-for="(item, index) in dataCt2" class="ct2-item">
                        <div class="ct2-item-left">
                            <div class="ct2-item-title">{{ item.title }}</div>
                            <div class="ct2-item-bottom">
                                <div class="ct2-item-number">{{ item.numbers }}</div>
                                <div class="ct2-item-unit">{{ item.unit }}</div>
                            </div>
                        </div>
                        <img class="ct2-item-right" src="@/assets/home/floor5/arrow-up.png" alt="">
                    </div>
                </div>
            </div>

            <div v-if="currentIndex == 2" class="container3 flex-row">
                <div v-for="(item, index) in dataCt3" class="item-ct3">
                    <img class="item-ct3-img" :src="item.src" alt="">
                    <div class="item-ct3-title">{{ item.title }}</div>
                    <div class="item-ct3-content">{{ item.content }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menus: ['权威认证', "技术保障", "售后服务"],
            currentIndex: 0,
            dataCt1: [
                {
                    title: '双软认证',
                    img: require('@/assets/home/floor5/icon1-1.png'),
                },
                {
                    title: '高新技术企业',
                    img: require('@/assets/home/floor5/icon1-2.png'),
                }, {
                    title: '企业信用等级证书<br>（aaa）',
                    img: require('@/assets/home/floor5/icon1-3.png'),
                }, {
                    title: '网络安全等级保护<br>2.0（三级）',
                    img: require('@/assets/home/floor5/icon1-4.png'),
                }, {
                    title: '质量管理体系认证',
                    img: require('@/assets/home/floor5/icon1-5.png'),
                },
            ],
            dataCt2: [
                {
                    title: '技术沉淀',
                    numbers: '12+',
                    unit: '年'
                },
                {
                    title: '创新产品',
                    numbers: '50+',
                    unit: '款'
                },
                {
                    title: '技术团队',
                    numbers: '200+',
                    unit: '人'
                },
                {
                    title: '软件著作',
                    numbers: '180+',
                    unit: '项'
                },
                {
                    title: '专利',
                    numbers: '30+',
                    unit: '项'
                },
            ],
            dataCt3: [
                {
                    title: '7*24小时服务',
                    content: '强大的售前售后团队。配备专门的服务人员及技术人员1v1服务确保客户碰到的问题第一时间予以解决',
                    src: require('@/assets/home/floor5/icon2-1.svg'),
                },
                {
                    title: '完美技术支持',
                    content: '产品手册、操作教程、使用培训、安装帮助一应俱全，为您提供完整的技术指导，使您快速上手',
                    src: require('@/assets/home/floor5/icon2-2.svg'),
                },
                {
                    title: '全方位服务',
                    content: '微信、电话等聊天工具全方位解答客户各种操作、技术难题，确保客户系统安全稳定，bug及时修复',
                    src: require('@/assets/home/floor5/icon2-3.svg'),
                },
                {
                    title: '全程指导',
                    content: '为各平台的搭建部署提供全程指导，即使创业小白，也能助您实现平台快速上线和运营',
                    src: require('@/assets/home/floor5/icon2-4.svg'),
                },
                {
                    title: '更多增值服务',
                    content: '将与您协同配合、提出优质的解决方案。持续跟进用户反馈，满足您的多方位其他需求',
                    src: require('@/assets/home/floor5/icon2-5.svg'),
                },
            ]
        };
    },

    methods: {
        handleMouseEnter(index) {
            this.currentIndex = index;
        }
    },
};
</script>

<style lang="less" scoped>
.f5-container {
    background: linear-gradient(180deg, #E3EFFF 0%, #FCFEFF 100%);
}

.floor5 {
    width: 1200px;
    height: 600px;
    margin: 0 auto;
    position: relative;
    background-image: url('~@/assets/home/floor5/bg.png');
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: 100% 300px;
}

.middle {
    display: flex;
    flex-direction: row;

    .menu {
        width: 1200px;
        margin-top: 73px;
        border-bottom-color: #1763FF;
        border-bottom-width: 1px;
        /* border-style: solid; */

        .menu-txt-sel {
            font-weight: bold;
            font-size: 22px;
            color: #222222;
            line-height: 24px;
        }

        .menu-txt {
            font-size: 22px;
            color: #222222;
            line-height: 24px;
        }

        .lin-sel {
            width: 400px;
            height: 4px;
            background: #1763FF;
            margin-top: 24px;
        }
    }


}

.line {
    width: 1200px;
    height: 1px;
    background-color: #1763FF;
    opacity: 0.3;
}

.flex-row {
    display: flex;
    flex-direction: row;

}
.center{
    justify-content: center;
}

.item-ct1 {
    margin-top: 79px;
    width: 220px;
    height: 200px;
    background: #FFFFFF;
    border-radius: 6px;
}

.item-ct1 img {
    width: 100px;
    height: 100px;
    margin-top: 25px;
}

.item-ct1 div {
    font-size: 16px;
    color: #222222;
    line-height: 20px;
    margin-top: 11px;
}

.container1 {
    justify-content: space-between;
}

.container2 {
    .ct2-title {
        font-size: 22px;
        color: #222222;
        line-height: 41px;
        margin-top: 62px;
    }

    .ct2-subtitle {
        font-family: MicrosoftYaHei;
        font-size: 22px;
        color: #1763FF;
        line-height: 41px;
        font-weight: bold;

    }

    .ct2-item {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 220px;
        height: 200px;

        .ct2-item-right {
            width: 36px;
            height: 51px;
        }

        .ct2-item-left {
            .ct2-item-title {
                font-family: MicrosoftYaHei;
                font-size: 16px;
                color: #222222;
                line-height: 41px;
            }

            .ct2-item-bottom {
                display: flex;
                flex-direction: row;
                align-items: baseline;

                .ct2-item-number {
                    font-weight: bold;
                    font-size: 46px;
                    color: #222222;
                }

                .ct2-item-unit {
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    color: #222222;
                    margin-left: 3px;
                }
            }
        }
    }
}

.container3 {
    justify-content: space-between;
    margin-top: 73px;
    .item-ct3 {
        width: 224px;
        height: 240px;
        background: #FFFFFF;
        border-radius: 6px;
        opacity: 0.8;

        padding: 30px 20px;

        .item-ct3-img {
            width: 40px;
            height: 40px;

        }

        .item-ct3-title {
            font-weight: bold;
            font-size: 18px;
            color: #222222;
            margin-top: 18px;
            margin-bottom: 12px;
        }

        .item-ct3-content {
            font-size: 14px;
            color: #222222;
            text-align: left
        }
    }
}
</style>
